import * as Types from '../../../../../graphql';

import { gql } from '@apollo/client';

/*
* This was automatically generated on by @graphql-codegen.
* DO NOT MANUALLY EDIT !!!
* Please refer to https://github.com/wistia/wistia/blob/main/frontend/graphql/README.md for more information.
* Last Updated: Tue Sep 02 2025 13:43:06 GMT+0000 (Coordinated Universal Time)
*/

export type CreateAccountTrialAccountFieldsFragment = { __typename?: 'Account', id: string, atChannelLimit: boolean, canCreateChannels: boolean, canCreateLiveStreamEvents: boolean, canStartTrials: boolean, channelsLimit?: number | null | undefined, formattedOwnerEmails: string, usersLimit?: number | null | undefined, liveEventAttendeesLimit?: number | null | undefined, liveEventAttendeeOveragePrice?: number | null | undefined, liveEventMinutesLimit?: number | null | undefined, liveEventMinuteOveragePrice?: number | null | undefined, experimentEnrollments: Array<{ __typename?: 'ExperimentEnrollment', id: string, key: string, group?: string | null | undefined, isLive: boolean }>, activeTrial?: { __typename?: 'Trial', id: string, active: boolean, endsAt: string, plan: { __typename?: 'Plan', id: string, sku?: string | null | undefined, name: string } } | null | undefined };

export type CreateAccountTrialContactFieldsFragment = { __typename?: 'Contact', id: string, isOwner: boolean, email: string, permissions: { __typename?: 'Permissions', canAccessABTests: boolean, canAccessAnalyticsAudience: boolean, canAccessAnalyticsDataExport: boolean, canAccessAnalyticsEmbedMediaStatsV2Details: boolean, canAccessAnalyticsHeatmaps: boolean, canAccessAnalyticsViewStreams: boolean, canAccessAnalyticsCompareMedia: boolean, canAccessChannels: boolean, canAccessChannelsLimited: boolean, canAccessCustomizeCtaHtml: boolean, canAccessCustomizeCtaImage: boolean, canAccessCustomizeCtaText: boolean, canAccessCustomizePassword: boolean, canAccessCustomizeTurnstile: boolean, canAccessOrderAudioDescriptions: boolean, canAccessLiveStream: boolean, canAccessLiveStreamCustomizeBranding: boolean } };

export const CreateAccountTrialAccountFieldsFragmentDoc = gql`
    fragment createAccountTrialAccountFields on Account {
  id
  atChannelLimit
  canCreateChannels
  canCreateLiveStreamEvents
  canStartTrials
  channelsLimit
  formattedOwnerEmails
  usersLimit
  liveEventAttendeesLimit
  liveEventAttendeeOveragePrice
  liveEventMinutesLimit
  liveEventMinuteOveragePrice
  experimentEnrollments {
    id
    key
    group
    isLive
  }
  activeTrial {
    id
    active
    endsAt
    plan {
      id
      sku
      name
    }
  }
}
    `;
export const CreateAccountTrialContactFieldsFragmentDoc = gql`
    fragment createAccountTrialContactFields on Contact {
  id
  isOwner
  email
  permissions {
    canAccessABTests
    canAccessAnalyticsAudience
    canAccessAnalyticsDataExport
    canAccessAnalyticsEmbedMediaStatsV2Details
    canAccessAnalyticsHeatmaps
    canAccessAnalyticsViewStreams
    canAccessAnalyticsCompareMedia
    canAccessChannels
    canAccessChannelsLimited
    canAccessCustomizeCtaHtml
    canAccessCustomizeCtaImage
    canAccessCustomizeCtaText
    canAccessCustomizePassword
    canAccessCustomizeTurnstile
    canAccessOrderAudioDescriptions
    canAccessLiveStream
    canAccessLiveStreamCustomizeBranding
  }
}
    `;